import Results from '@pelckmans/elementis/components/results';
import { getResultPercentages, Status } from '../../../../utils/results';

export interface ScorableProgressProps {
  unachievable?: boolean;
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
    status?: Status;
  };
}

export default function ScorableProgress({ unachievable = false, score }: ScorableProgressProps) {
  const status = score?.status ? score.status : 'not-started';

  if (unachievable) {
    return <Results quantifiable={false} status={status} showTooltip variant="full" />;
  }

  return (
    <Results
      quantifiable
      status={status}
      showTooltip
      variant="full"
      {...getResultPercentages(score, status === 'pending-grading')}
    />
  );
}
